import type { TFunction } from "i18next";
import * as z from "zod";

export const companyGroupFormSchema = (t: TFunction) => {
  return z.object({
    name: z.string().nonempty(t("field_required")),
    description: z.string().optional(),
    companies: z
      .array(z.string())
      .min(1, t("company_group_form_companies_min_length")),
    updatedAt: z.string().optional(),
  });
};

export type CompanyGroupFormSchemaValues = z.infer<
  ReturnType<typeof companyGroupFormSchema>
>;
